export default {
  props: {
    producer_id: {},
    harvest_process_id: {},
  },
}
